export default function() {
  if (process.client) {
    window.addEventListener(
      'CookieInformationConsentGiven',
      function() {
        if (CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
          console.log('GA4 consent granted — initializing gtag');

          window.dataLayer = window.dataLayer || [];

          function gtag() {
            window.dataLayer.push(arguments);
          }

          window.gtag = gtag;

          gtag('js', new Date());

          gtag('consent', 'update', {
            ad_storage: 'granted',
            analytics_storage: 'granted',
            ad_user_data: 'granted',
            ad_personalization: 'granted'
          });

          gtag('config', process.env.GA_MEASUREMENT_ID);
        } else {
          console.log('GA4: Consent not granted, skipping gtag init');
        }
      },
      false
    );
  }
}
